<template>
  <section class="page">
    <!-- Vue tag to add header component -->
    <header-prismic/>
    <section class="page-banner" :style="{ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url(' + pageBannerImage + ')' }">
      <!-- Template for page title. -->
      <div class="banner-content container">
      </div>
    </section>
    <div class="container">
      <div class="page-title">
        <h1>{{ pageTitle }}</h1>
      </div>
      <!-- Slices block component -->
      <slices-block :slices="slices"/>
    </div>
  </section>
</template>

<script>
// imports for all components
import HeaderPrismic from '../components/HeaderPrismic.vue'
import SlicesBlock from '../components/SlicesBlock.vue'

export default {
  name: 'page',
  components: {
    HeaderPrismic,
    SlicesBlock,
  },
  data () {
    return {
      documentId: '',
      pageTitle: '',
      pageBannerImage: '',
      slices: []
    }
  },
  methods: {
    getContent (uid) {
      //Query to get post content
      this.$prismic.client.getByUID('page', uid)
        .then((document) => {
          if (document) {
            this.documentId = document.id;
            this.pageTitle = document.data.title[0].text;
            const banner = document.data.page_banner[0];
            this.pageBannerImage = banner.image.url;

            //Set slices as variable
            this.slices = document.data.page_content
          }
          else {
            //returns error page
            this.$router.push({ name: 'not-found' })
          }
        })
    }
  },
  created () {
    this.getContent(this.$route.params.uid)
  },
  beforeRouteUpdate (to, from, next) {
    this.getContent(to.params.uid)
    next()
  }
}
</script>

<style>
.page-banner {
  margin: -70px 0 80px;
  padding: 10em 0 8em;
  background-position: center center;
  background-size: cover;
  color: #778170;
  line-height: 1.75;
  text-align: center;
}

.page-title {
  margin-top: -120px;
}


@media (max-width: 767px) {
  .page-title {
    display: none;
  }

  .page-banner {
    margin: 0 0 40px;
    padding: 10em 0 6em;
  }

}

</style>
